module.exports = __webpack_public_path__ + "static/media/2.73bb5db0.png";